(function () {
  if (window.AL_APPLICATOR_OFFER_BOUND) return;
  window.AL_APPLICATOR_OFFER_BOUND = true;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-al-applicator-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var offer = button.closest('[data-al-applicator-offer]');
    var error = offer.querySelector('[data-al-applicator-error]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;
    error.hidden = true;
    try {
      var response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Please refresh your basket and try again.');
      var cart = await response.json();
      var variant = Number(button.dataset.alApplicatorAdd);
      var eligible = cart.items.some(function (item) { return item.variant_id === 63513112150346; });
      var excluded = cart.items.some(function (item) { return item.variant_id === 63513112183114 || item.variant_id === variant; });
      if (!eligible || excluded) { var staleDrawer = document.querySelector('cart-drawer'); if (staleDrawer && staleDrawer.refresh) { await staleDrawer.refresh(); } else { window.location.href = root + 'cart'; } return; }
      response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Please try again.');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.renderContents) { drawer.renderContents(result); } else { window.location.href = root + 'cart'; }
    } catch (err) {
      error.textContent = err.message || 'Please refresh your basket and try again.';
      error.hidden = false;
      button.disabled = false;
    }
  });
}());
